
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class FrendsExpressionLexer extends antlr.Lexer {
    public static readonly EACH_OPEN = 1;
    public static readonly END_EACH_TAG = 2;
    public static readonly IF_OPEN = 3;
    public static readonly ELSE_IF_OPEN = 4;
    public static readonly ELSE_TAG = 5;
    public static readonly END_IF_TAG = 6;
    public static readonly OPEN_BRACES = 7;
    public static readonly STRING = 8;
    public static readonly CLOSE_BRACES = 9;
    public static readonly VAR_REF = 10;
    public static readonly TRIGGER_REF = 11;
    public static readonly PROCESS_REF = 12;
    public static readonly ENV_REF_START = 13;
    public static readonly RESULT_NODE_REF = 14;
    public static readonly RESULT_REF = 15;
    public static readonly THIS_REF = 16;
    public static readonly INDEX_REF = 17;
    public static readonly SOURCE_REF = 18;
    public static readonly CS_TEXT = 19;
    public static readonly ENV_VAR_VALUE = 20;
    public static readonly CSHARP_MODE = 1;
    public static readonly CSHARP_MODE_NO_EXIT = 2;
    public static readonly READ_LAST_ENV_VAR_SEGMENT = 3;
    public static readonly READ_LAST_ENV_VAR_SEGMENT_NO_EXIT = 4;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, null, null, null, null, "'{{'", null, "'}}'"
    ];

    public static readonly symbolicNames = [
        null, "EACH_OPEN", "END_EACH_TAG", "IF_OPEN", "ELSE_IF_OPEN", "ELSE_TAG", 
        "END_IF_TAG", "OPEN_BRACES", "STRING", "CLOSE_BRACES", "VAR_REF", 
        "TRIGGER_REF", "PROCESS_REF", "ENV_REF_START", "RESULT_NODE_REF", 
        "RESULT_REF", "THIS_REF", "INDEX_REF", "SOURCE_REF", "CS_TEXT", 
        "ENV_VAR_VALUE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE", "CSHARP_MODE", "CSHARP_MODE_NO_EXIT", "READ_LAST_ENV_VAR_SEGMENT", 
        "READ_LAST_ENV_VAR_SEGMENT_NO_EXIT",
    ];

    public static readonly ruleNames = [
        "EACH_OPEN", "END_EACH_TAG", "IF_OPEN", "ELSE_IF_OPEN", "ELSE_TAG", 
        "END_IF_TAG", "OPEN_BRACES", "STRING", "CLOSE_BRACES", "VAR_REF", 
        "TRIGGER_REF", "PROCESS_REF", "ENV_REF_START", "RESULT_NODE_REF", 
        "RESULT_REF", "THIS_REF", "INDEX_REF", "SOURCE_REF", "CS_TEXT", 
        "VAR_REF_NO_EXIT", "TRIGGER_REF_NO_EXIT", "PROCESS_REF_NO_EXIT", 
        "ENV_REF_START_NO_EXIT", "RESULT_NODE_REF_NO_EXIT", "RESULT_REF_NO_EXIT", 
        "THIS_REF_NO_EXIT", "INDEX_REF_NO_EXIT", "SOURCE_REF_NO_EXIT", "CS_TEXT_NO_EXIT", 
        "CLOSE_BRACES_IN_ENV", "FUNCTION_CALL", "ENV_VAR_VALUE", "NOT_SEGMENT", 
        "FUNCTION_CALL_NO_EXIT", "ENV_VAR_VALUE_NO_EXIT", "NOT_SEGMENT_NO_EXIT", 
        "ID_CHAR", "WS",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, FrendsExpressionLexer._ATN, FrendsExpressionLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "FrendsExpressionLexer.g4"; }

    public get literalNames(): (string | null)[] { return FrendsExpressionLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return FrendsExpressionLexer.symbolicNames; }
    public get ruleNames(): string[] { return FrendsExpressionLexer.ruleNames; }

    public get serializedATN(): number[] { return FrendsExpressionLexer._serializedATN; }

    public get channelNames(): string[] { return FrendsExpressionLexer.channelNames; }

    public get modeNames(): string[] { return FrendsExpressionLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,20,534,6,-1,6,-1,6,-1,6,-1,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,
        7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,
        11,7,11,2,12,7,12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,
        17,2,18,7,18,2,19,7,19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,
        24,7,24,2,25,7,25,2,26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,
        30,2,31,7,31,2,32,7,32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,
        37,7,37,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,4,7,172,8,7,11,7,
        12,7,173,1,7,3,7,177,8,7,1,8,1,8,1,8,1,8,1,8,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,4,9,191,8,9,11,9,12,9,192,5,9,195,8,9,10,9,12,9,198,9,9,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,4,10,211,
        8,10,11,10,12,10,212,3,10,215,8,10,1,11,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,11,1,11,1,11,4,11,228,8,11,11,11,12,11,229,3,11,232,
        8,11,1,12,1,12,1,12,1,12,1,12,1,12,1,12,4,12,241,8,12,11,12,12,12,
        242,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,
        5,13,257,8,13,10,13,12,13,260,9,13,1,13,1,13,1,14,1,14,1,14,1,14,
        1,14,1,14,1,14,1,14,1,14,1,14,5,14,274,8,14,10,14,12,14,277,9,14,
        1,15,1,15,1,15,1,15,1,15,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,17,
        1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,4,17,301,8,17,11,17,
        12,17,302,5,17,305,8,17,10,17,12,17,308,9,17,1,18,4,18,311,8,18,
        11,18,12,18,312,1,18,3,18,316,8,18,1,19,1,19,1,19,1,19,1,19,1,19,
        1,19,4,19,325,8,19,11,19,12,19,326,5,19,329,8,19,10,19,12,19,332,
        9,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,4,20,347,8,20,11,20,12,20,348,3,20,351,8,20,1,20,1,20,1,21,
        1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,4,21,366,8,21,
        11,21,12,21,367,3,21,370,8,21,1,21,1,21,1,22,1,22,1,22,1,22,1,22,
        1,22,1,22,4,22,381,8,22,11,22,12,22,382,1,22,1,22,1,22,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,5,23,398,8,23,10,23,12,23,
        401,9,23,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,1,24,1,24,5,24,417,8,24,10,24,12,24,420,9,24,1,24,1,24,1,25,
        1,25,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,4,27,
        450,8,27,11,27,12,27,451,5,27,454,8,27,10,27,12,27,457,9,27,1,27,
        1,27,1,28,4,28,462,8,28,11,28,12,28,463,1,28,3,28,467,8,28,1,28,
        1,28,1,29,1,29,1,29,1,29,1,29,1,29,1,29,1,30,1,30,4,30,480,8,30,
        11,30,12,30,481,1,30,1,30,1,30,1,30,1,30,1,31,1,31,4,31,491,8,31,
        11,31,12,31,492,1,31,1,31,1,32,1,32,1,32,1,32,1,32,1,33,1,33,4,33,
        504,8,33,11,33,12,33,505,1,33,1,33,1,33,1,33,1,33,1,34,1,34,4,34,
        515,8,34,11,34,12,34,516,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,35,
        1,36,1,36,1,37,5,37,530,8,37,10,37,12,37,533,9,37,0,0,38,5,1,7,2,
        9,3,11,4,13,5,15,6,17,7,19,8,21,9,23,10,25,11,27,12,29,13,31,14,
        33,15,35,16,37,17,39,18,41,19,43,0,45,0,47,0,49,0,51,0,53,0,55,0,
        57,0,59,0,61,0,63,0,65,0,67,20,69,0,71,0,73,0,75,0,77,0,79,0,5,0,
        1,2,3,4,24,2,0,69,69,101,101,2,0,65,65,97,97,2,0,67,67,99,99,2,0,
        72,72,104,104,2,0,73,73,105,105,2,0,70,70,102,102,2,0,76,76,108,
        108,2,0,83,83,115,115,1,0,123,123,2,0,86,86,118,118,2,0,82,82,114,
        114,2,0,84,84,116,116,2,0,71,71,103,103,2,0,80,80,112,112,2,0,79,
        79,111,111,2,0,78,78,110,110,2,0,85,85,117,117,1,0,93,93,2,0,68,
        68,100,100,2,0,88,88,120,120,5,0,35,35,64,64,84,84,116,116,125,125,
        4,0,35,35,64,64,84,84,116,116,8,0,48,57,65,90,95,95,97,122,196,197,
        214,214,228,229,246,246,3,0,9,10,13,13,32,32,561,0,5,1,0,0,0,0,7,
        1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,
        1,0,0,0,0,19,1,0,0,0,1,21,1,0,0,0,1,23,1,0,0,0,1,25,1,0,0,0,1,27,
        1,0,0,0,1,29,1,0,0,0,1,31,1,0,0,0,1,33,1,0,0,0,1,35,1,0,0,0,1,37,
        1,0,0,0,1,39,1,0,0,0,1,41,1,0,0,0,2,43,1,0,0,0,2,45,1,0,0,0,2,47,
        1,0,0,0,2,49,1,0,0,0,2,51,1,0,0,0,2,53,1,0,0,0,2,55,1,0,0,0,2,57,
        1,0,0,0,2,59,1,0,0,0,2,61,1,0,0,0,3,63,1,0,0,0,3,65,1,0,0,0,3,67,
        1,0,0,0,3,69,1,0,0,0,4,71,1,0,0,0,4,73,1,0,0,0,4,75,1,0,0,0,5,81,
        1,0,0,0,7,95,1,0,0,0,9,109,1,0,0,0,11,121,1,0,0,0,13,138,1,0,0,0,
        15,151,1,0,0,0,17,163,1,0,0,0,19,176,1,0,0,0,21,178,1,0,0,0,23,183,
        1,0,0,0,25,199,1,0,0,0,27,216,1,0,0,0,29,233,1,0,0,0,31,246,1,0,
        0,0,33,263,1,0,0,0,35,278,1,0,0,0,37,283,1,0,0,0,39,290,1,0,0,0,
        41,315,1,0,0,0,43,317,1,0,0,0,45,335,1,0,0,0,47,354,1,0,0,0,49,373,
        1,0,0,0,51,387,1,0,0,0,53,406,1,0,0,0,55,423,1,0,0,0,57,430,1,0,
        0,0,59,439,1,0,0,0,61,466,1,0,0,0,63,470,1,0,0,0,65,477,1,0,0,0,
        67,488,1,0,0,0,69,496,1,0,0,0,71,501,1,0,0,0,73,512,1,0,0,0,75,521,
        1,0,0,0,77,526,1,0,0,0,79,531,1,0,0,0,81,82,5,123,0,0,82,83,5,123,
        0,0,83,84,1,0,0,0,84,85,3,79,37,0,85,86,5,35,0,0,86,87,7,0,0,0,87,
        88,7,1,0,0,88,89,7,2,0,0,89,90,7,3,0,0,90,91,1,0,0,0,91,92,3,79,
        37,0,92,93,1,0,0,0,93,94,6,0,0,0,94,6,1,0,0,0,95,96,5,123,0,0,96,
        97,5,123,0,0,97,98,1,0,0,0,98,99,3,79,37,0,99,100,5,47,0,0,100,101,
        7,0,0,0,101,102,7,1,0,0,102,103,7,2,0,0,103,104,7,3,0,0,104,105,
        1,0,0,0,105,106,3,79,37,0,106,107,5,125,0,0,107,108,5,125,0,0,108,
        8,1,0,0,0,109,110,5,123,0,0,110,111,5,123,0,0,111,112,1,0,0,0,112,
        113,3,79,37,0,113,114,5,35,0,0,114,115,7,4,0,0,115,116,7,5,0,0,116,
        117,1,0,0,0,117,118,3,79,37,0,118,119,1,0,0,0,119,120,6,2,0,0,120,
        10,1,0,0,0,121,122,5,123,0,0,122,123,5,123,0,0,123,124,1,0,0,0,124,
        125,3,79,37,0,125,126,7,0,0,0,126,127,7,6,0,0,127,128,7,7,0,0,128,
        129,7,0,0,0,129,130,1,0,0,0,130,131,3,79,37,0,131,132,7,4,0,0,132,
        133,7,5,0,0,133,134,1,0,0,0,134,135,3,79,37,0,135,136,1,0,0,0,136,
        137,6,3,0,0,137,12,1,0,0,0,138,139,5,123,0,0,139,140,5,123,0,0,140,
        141,1,0,0,0,141,142,3,79,37,0,142,143,7,0,0,0,143,144,7,6,0,0,144,
        145,7,7,0,0,145,146,7,0,0,0,146,147,1,0,0,0,147,148,3,79,37,0,148,
        149,5,125,0,0,149,150,5,125,0,0,150,14,1,0,0,0,151,152,5,123,0,0,
        152,153,5,123,0,0,153,154,1,0,0,0,154,155,3,79,37,0,155,156,5,47,
        0,0,156,157,7,4,0,0,157,158,7,5,0,0,158,159,1,0,0,0,159,160,3,79,
        37,0,160,161,5,125,0,0,161,162,5,125,0,0,162,16,1,0,0,0,163,164,
        5,123,0,0,164,165,5,123,0,0,165,166,1,0,0,0,166,167,6,6,0,0,167,
        18,1,0,0,0,168,172,8,8,0,0,169,170,5,123,0,0,170,172,8,8,0,0,171,
        168,1,0,0,0,171,169,1,0,0,0,172,173,1,0,0,0,173,171,1,0,0,0,173,
        174,1,0,0,0,174,177,1,0,0,0,175,177,5,123,0,0,176,171,1,0,0,0,176,
        175,1,0,0,0,177,20,1,0,0,0,178,179,5,125,0,0,179,180,5,125,0,0,180,
        181,1,0,0,0,181,182,6,8,1,0,182,22,1,0,0,0,183,184,5,35,0,0,184,
        185,7,9,0,0,185,186,7,1,0,0,186,187,7,10,0,0,187,196,1,0,0,0,188,
        190,5,46,0,0,189,191,3,77,36,0,190,189,1,0,0,0,191,192,1,0,0,0,192,
        190,1,0,0,0,192,193,1,0,0,0,193,195,1,0,0,0,194,188,1,0,0,0,195,
        198,1,0,0,0,196,194,1,0,0,0,196,197,1,0,0,0,197,24,1,0,0,0,198,196,
        1,0,0,0,199,200,5,35,0,0,200,201,7,11,0,0,201,202,7,10,0,0,202,203,
        7,4,0,0,203,204,7,12,0,0,204,205,7,12,0,0,205,206,7,0,0,0,206,207,
        7,10,0,0,207,214,1,0,0,0,208,210,5,46,0,0,209,211,3,77,36,0,210,
        209,1,0,0,0,211,212,1,0,0,0,212,210,1,0,0,0,212,213,1,0,0,0,213,
        215,1,0,0,0,214,208,1,0,0,0,214,215,1,0,0,0,215,26,1,0,0,0,216,217,
        5,35,0,0,217,218,7,13,0,0,218,219,7,10,0,0,219,220,7,14,0,0,220,
        221,7,2,0,0,221,222,7,0,0,0,222,223,7,7,0,0,223,224,7,7,0,0,224,
        231,1,0,0,0,225,227,5,46,0,0,226,228,3,77,36,0,227,226,1,0,0,0,228,
        229,1,0,0,0,229,227,1,0,0,0,229,230,1,0,0,0,230,232,1,0,0,0,231,
        225,1,0,0,0,231,232,1,0,0,0,232,28,1,0,0,0,233,234,5,35,0,0,234,
        235,7,0,0,0,235,236,7,15,0,0,236,237,7,9,0,0,237,238,1,0,0,0,238,
        240,5,46,0,0,239,241,3,77,36,0,240,239,1,0,0,0,241,242,1,0,0,0,242,
        240,1,0,0,0,242,243,1,0,0,0,243,244,1,0,0,0,244,245,6,12,2,0,245,
        30,1,0,0,0,246,247,5,35,0,0,247,248,7,10,0,0,248,249,7,0,0,0,249,
        250,7,7,0,0,250,251,7,16,0,0,251,252,7,6,0,0,252,253,7,11,0,0,253,
        254,1,0,0,0,254,258,5,91,0,0,255,257,8,17,0,0,256,255,1,0,0,0,257,
        260,1,0,0,0,258,256,1,0,0,0,258,259,1,0,0,0,259,261,1,0,0,0,260,
        258,1,0,0,0,261,262,5,93,0,0,262,32,1,0,0,0,263,264,5,35,0,0,264,
        265,7,10,0,0,265,266,7,0,0,0,266,267,7,7,0,0,267,268,7,16,0,0,268,
        269,7,6,0,0,269,270,7,11,0,0,270,275,1,0,0,0,271,272,5,46,0,0,272,
        274,3,77,36,0,273,271,1,0,0,0,274,277,1,0,0,0,275,273,1,0,0,0,275,
        276,1,0,0,0,276,34,1,0,0,0,277,275,1,0,0,0,278,279,7,11,0,0,279,
        280,7,3,0,0,280,281,7,4,0,0,281,282,7,7,0,0,282,36,1,0,0,0,283,284,
        5,64,0,0,284,285,7,4,0,0,285,286,7,15,0,0,286,287,7,18,0,0,287,288,
        7,0,0,0,288,289,7,19,0,0,289,38,1,0,0,0,290,291,5,35,0,0,291,292,
        7,7,0,0,292,293,7,14,0,0,293,294,7,16,0,0,294,295,7,10,0,0,295,296,
        7,2,0,0,296,297,7,0,0,0,297,306,1,0,0,0,298,300,5,46,0,0,299,301,
        3,77,36,0,300,299,1,0,0,0,301,302,1,0,0,0,302,300,1,0,0,0,302,303,
        1,0,0,0,303,305,1,0,0,0,304,298,1,0,0,0,305,308,1,0,0,0,306,304,
        1,0,0,0,306,307,1,0,0,0,307,40,1,0,0,0,308,306,1,0,0,0,309,311,8,
        20,0,0,310,309,1,0,0,0,311,312,1,0,0,0,312,310,1,0,0,0,312,313,1,
        0,0,0,313,316,1,0,0,0,314,316,7,20,0,0,315,310,1,0,0,0,315,314,1,
        0,0,0,316,42,1,0,0,0,317,318,5,35,0,0,318,319,7,9,0,0,319,320,7,
        1,0,0,320,321,7,10,0,0,321,330,1,0,0,0,322,324,5,46,0,0,323,325,
        3,77,36,0,324,323,1,0,0,0,325,326,1,0,0,0,326,324,1,0,0,0,326,327,
        1,0,0,0,327,329,1,0,0,0,328,322,1,0,0,0,329,332,1,0,0,0,330,328,
        1,0,0,0,330,331,1,0,0,0,331,333,1,0,0,0,332,330,1,0,0,0,333,334,
        6,19,3,0,334,44,1,0,0,0,335,336,5,35,0,0,336,337,7,11,0,0,337,338,
        7,10,0,0,338,339,7,4,0,0,339,340,7,12,0,0,340,341,7,12,0,0,341,342,
        7,0,0,0,342,343,7,10,0,0,343,350,1,0,0,0,344,346,5,46,0,0,345,347,
        3,77,36,0,346,345,1,0,0,0,347,348,1,0,0,0,348,346,1,0,0,0,348,349,
        1,0,0,0,349,351,1,0,0,0,350,344,1,0,0,0,350,351,1,0,0,0,351,352,
        1,0,0,0,352,353,6,20,4,0,353,46,1,0,0,0,354,355,5,35,0,0,355,356,
        7,13,0,0,356,357,7,10,0,0,357,358,7,14,0,0,358,359,7,2,0,0,359,360,
        7,0,0,0,360,361,7,7,0,0,361,362,7,7,0,0,362,369,1,0,0,0,363,365,
        5,46,0,0,364,366,3,77,36,0,365,364,1,0,0,0,366,367,1,0,0,0,367,365,
        1,0,0,0,367,368,1,0,0,0,368,370,1,0,0,0,369,363,1,0,0,0,369,370,
        1,0,0,0,370,371,1,0,0,0,371,372,6,21,5,0,372,48,1,0,0,0,373,374,
        5,35,0,0,374,375,7,0,0,0,375,376,7,15,0,0,376,377,7,9,0,0,377,378,
        1,0,0,0,378,380,5,46,0,0,379,381,3,77,36,0,380,379,1,0,0,0,381,382,
        1,0,0,0,382,380,1,0,0,0,382,383,1,0,0,0,383,384,1,0,0,0,384,385,
        6,22,6,0,385,386,6,22,7,0,386,50,1,0,0,0,387,388,5,35,0,0,388,389,
        7,10,0,0,389,390,7,0,0,0,390,391,7,7,0,0,391,392,7,16,0,0,392,393,
        7,6,0,0,393,394,7,11,0,0,394,395,1,0,0,0,395,399,5,91,0,0,396,398,
        8,17,0,0,397,396,1,0,0,0,398,401,1,0,0,0,399,397,1,0,0,0,399,400,
        1,0,0,0,400,402,1,0,0,0,401,399,1,0,0,0,402,403,5,93,0,0,403,404,
        1,0,0,0,404,405,6,23,8,0,405,52,1,0,0,0,406,407,5,35,0,0,407,408,
        7,10,0,0,408,409,7,0,0,0,409,410,7,7,0,0,410,411,7,16,0,0,411,412,
        7,6,0,0,412,413,7,11,0,0,413,418,1,0,0,0,414,415,5,46,0,0,415,417,
        3,77,36,0,416,414,1,0,0,0,417,420,1,0,0,0,418,416,1,0,0,0,418,419,
        1,0,0,0,419,421,1,0,0,0,420,418,1,0,0,0,421,422,6,24,9,0,422,54,
        1,0,0,0,423,424,7,11,0,0,424,425,7,3,0,0,425,426,7,4,0,0,426,427,
        7,7,0,0,427,428,1,0,0,0,428,429,6,25,10,0,429,56,1,0,0,0,430,431,
        5,64,0,0,431,432,7,4,0,0,432,433,7,15,0,0,433,434,7,18,0,0,434,435,
        7,0,0,0,435,436,7,19,0,0,436,437,1,0,0,0,437,438,6,26,11,0,438,58,
        1,0,0,0,439,440,5,35,0,0,440,441,7,7,0,0,441,442,7,14,0,0,442,443,
        7,16,0,0,443,444,7,10,0,0,444,445,7,2,0,0,445,446,7,0,0,0,446,455,
        1,0,0,0,447,449,5,46,0,0,448,450,3,77,36,0,449,448,1,0,0,0,450,451,
        1,0,0,0,451,449,1,0,0,0,451,452,1,0,0,0,452,454,1,0,0,0,453,447,
        1,0,0,0,454,457,1,0,0,0,455,453,1,0,0,0,455,456,1,0,0,0,456,458,
        1,0,0,0,457,455,1,0,0,0,458,459,6,27,12,0,459,60,1,0,0,0,460,462,
        8,21,0,0,461,460,1,0,0,0,462,463,1,0,0,0,463,461,1,0,0,0,463,464,
        1,0,0,0,464,467,1,0,0,0,465,467,7,21,0,0,466,461,1,0,0,0,466,465,
        1,0,0,0,467,468,1,0,0,0,468,469,6,28,13,0,469,62,1,0,0,0,470,471,
        5,125,0,0,471,472,5,125,0,0,472,473,1,0,0,0,473,474,6,29,1,0,474,
        475,6,29,1,0,475,476,6,29,14,0,476,64,1,0,0,0,477,479,5,46,0,0,478,
        480,3,77,36,0,479,478,1,0,0,0,480,481,1,0,0,0,481,479,1,0,0,0,481,
        482,1,0,0,0,482,483,1,0,0,0,483,484,5,40,0,0,484,485,1,0,0,0,485,
        486,6,30,1,0,486,487,6,30,13,0,487,66,1,0,0,0,488,490,5,46,0,0,489,
        491,3,77,36,0,490,489,1,0,0,0,491,492,1,0,0,0,492,490,1,0,0,0,492,
        493,1,0,0,0,493,494,1,0,0,0,494,495,6,31,1,0,495,68,1,0,0,0,496,
        497,9,0,0,0,497,498,1,0,0,0,498,499,6,32,1,0,499,500,6,32,13,0,500,
        70,1,0,0,0,501,503,5,46,0,0,502,504,3,77,36,0,503,502,1,0,0,0,504,
        505,1,0,0,0,505,503,1,0,0,0,505,506,1,0,0,0,506,507,1,0,0,0,507,
        508,5,40,0,0,508,509,1,0,0,0,509,510,6,33,1,0,510,511,6,33,13,0,
        511,72,1,0,0,0,512,514,5,46,0,0,513,515,3,77,36,0,514,513,1,0,0,
        0,515,516,1,0,0,0,516,514,1,0,0,0,516,517,1,0,0,0,517,518,1,0,0,
        0,518,519,6,34,1,0,519,520,6,34,15,0,520,74,1,0,0,0,521,522,9,0,
        0,0,522,523,1,0,0,0,523,524,6,35,1,0,524,525,6,35,13,0,525,76,1,
        0,0,0,526,527,7,22,0,0,527,78,1,0,0,0,528,530,7,23,0,0,529,528,1,
        0,0,0,530,533,1,0,0,0,531,529,1,0,0,0,531,532,1,0,0,0,532,80,1,0,
        0,0,533,531,1,0,0,0,39,0,1,2,3,4,171,173,176,192,196,212,214,229,
        231,242,258,275,302,306,312,315,326,330,348,350,367,369,382,399,
        418,451,455,463,466,481,492,505,516,531,16,5,1,0,4,0,0,5,3,0,7,10,
        0,7,11,0,7,12,0,5,4,0,7,13,0,7,14,0,7,15,0,7,16,0,7,17,0,7,18,0,
        7,19,0,7,9,0,7,20,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!FrendsExpressionLexer.__ATN) {
            FrendsExpressionLexer.__ATN = new antlr.ATNDeserializer().deserialize(FrendsExpressionLexer._serializedATN);
        }

        return FrendsExpressionLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(FrendsExpressionLexer.literalNames, FrendsExpressionLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return FrendsExpressionLexer.vocabulary;
    }

    private static readonly decisionsToDFA = FrendsExpressionLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}